export const paymentConsts = {
  PLATFORM_USAGE_FEE_MINIMUM_EUR: 1000,
};
